const useUtmParams = () => {
    const keys = ['utm_source', 'utm_medium', 'utm_campaign', 'affiliate_id']
    const utmParams = {}
    keys.forEach((key) => {
        const cookieValue = document.cookie
            .split('; ')
            .find((row) => row.startsWith(key + '='))
            ?.split('=')[1]
        if (cookieValue) {
            utmParams[key] = cookieValue
        }
    })

    return utmParams
}

export default useUtmParams
